import { AssetServersTopology } from '@components';
import { useCompany } from '@hooks';
import { AssetsService } from '@services';
import { ModuleGuard } from '@utils/guards';
import React, { useEffect, useState } from 'react';

export const AssetServersContainer = () => {
  const [servers, setServers] = useState();
  const { companyId } = useCompany();
  const service = new AssetsService();

  const getServers = async () => {
    if (!companyId) return;
    const servers = await service.listCompanyServers(companyId);
    setServers(servers.servers);
  };

  useEffect(() => {
    getServers();
  }, [companyId]);

  return (
    <div>
      <ModuleGuard modules={['IT']}>
        {servers && (
          <>
            <AssetServersTopology servers={servers} />
          </>
        )}
      </ModuleGuard>
    </div>
  );
};

export default AssetServersContainer;
